/** YYYY-MM-01 → "July 2026" (en-US, UTC). */
export function formatClampForecastExpectedShipMonthLabel(planMonthIso: string): string {
  const trimmed = planMonthIso.trim();
  if (!/^\d{4}-\d{2}-01$/.test(trimmed)) {
    return trimmed.length > 0 ? trimmed : "unknown month";
  }
  const date = new Date(`${trimmed}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime())) return trimmed;
  return date.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

/**
 * Default Megaventory PO comments for a clamp forecast month: "July 2026", not "Expected ship: …".
 */
export function buildClampForecastPurchaseOrderComments(
  planMonthIso: string,
  userComments?: string | null,
): string {
  const monthLine = formatClampForecastExpectedShipMonthLabel(planMonthIso);
  const notes = userComments?.trim() ?? "";
  if (notes === "") return monthLine;
  const lowerNotes = notes.toLowerCase();
  const lowerMonth = monthLine.toLowerCase();
  if (lowerNotes === lowerMonth || lowerNotes.includes(lowerMonth)) {
    return notes;
  }
  return `${monthLine}\n${notes}`;
}
